import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import GtmAnalysisPage from '@/pages/gtm-workspace/analysis'
import { GTM_WORKSPACE_ANALYSIS_STAGE_COUNT } from '@/features/gtm/domain/gtm-run-stages'
import { requireGtmWorkspace } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  project: z.string().uuid().optional(),
  step: z.coerce.number().int().min(1).max(6).catch(1),
})

export const Route = createFileRoute('/$lang/workspace/$workspaceId/gtm/')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ context, params, search }) => {
    await requireGtmWorkspace(context, params)
    // Old links to the demo's sixth stage (emails): drafts live in Leads.
    if (search.step > GTM_WORKSPACE_ANALYSIS_STAGE_COUNT) {
      throw redirect({
        to: '/$lang/workspace/$workspaceId/gtm/leads',
        params,
        search: { project: search.project },
        replace: true,
      })
    }
  },
  component: GtmAnalysisPage,
  staticData: { layout: 'main' },
})
